import React from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import HeaderSection from "../components/head-section";
import IMG8 from '../../assets/8.png'
import IMG9 from '../../assets/9.png'
import IMG10 from '../../assets/10.png'
import { useHistory } from "react-router-dom";
const OurStory = () =>{
    const history = useHistory()
    return (
        <div>
            <Header whihOne="ourstory" />
               <HeaderSection name="Our Story" />
               <section id="second_s_homepage">
               <div id="word_div">
                    <div className="row col-12 ">
                        <div className="col">
                            <p id="word_header">OUR STORY</p>
                            <p id="word_header_2">
                            Meet The Smart 
                            <br />
                            Shopper
                            </p>
                            <p id="text_word_p">
                            The idea of The Smart Shopper came from a personal experience, due to a lack of information, affordability and convenience factors from our founder whilst moving back to Rwanda. She always asked around where she could find different items in Kigali. Like any good innovator, she found a way to solve this problem using technology.
                            <br/>
                            <br />
                            
                            The Smart Shopper is a digital enabled marketplace which aspires to be the number one go to shopping destination for affordable furniture.
                            <br/>
                            <br />
                            The Smart Shopper connects buyers and sellers through a matchmaking scenario by creating convenience, value and great customer experience.
                            </p>
                            <button id="learnMoare_buttom"
                            onClick={(()=>{
                                history.push('/carreer')
                            })}
                            >
                                Learn More
                            </button>
                        </div>
                        <div className="col"
                        id="word_div_right_side"
                        >
                                <div className="row col-12 noMP">
                                    <div className="col mag-A">
                                        <div
                                        style={{
                                            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG8})`,
                                            backgroundSize:"cover",
                                            height:"370px",
                                            width:"100%",
                                            backgroundRepeat:"no-repeat",
                                        }}
                                        >

                                        </div>
                                    </div>
                                    <br/>
                                    <div className="col noMP">
                                        <div
                                         style={{
                                            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG9})`,
                                            backgroundSize:"cover",
                                            height:"305px",
                                            width:"100%",
                                            marginBottom:"15px",
                                            backgroundRepeat:"no-repeat",
                                        }}
                                        >

                                        </div>
                                        <div
                                         style={{
                                            background: `linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)), url(${IMG10})`,
                                            backgroundSize:"cover",
                                            height:"220px",
                                            width:"100%",
                                            backgroundRepeat:"no-repeat",
                                        }}
                                        >

                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                    </div>     
               </section>

            <Footer />
        </div>
    )
}
export default OurStory;
